import React, { Component } from 'react';
import moment from 'moment-jalaali';
import { requestState } from "../../constants/enum.constants";

class CertReqPartial extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 


        const {model} = this.props;

        return (  

            <div class="panel panel-default">
                <div class="panel-heading">
                    <a data-toggle = "collapse" href = "#certreq">
                    <b>شماره گواهی: </b>  {model && model.UniqueNo }  &nbsp;&nbsp;  
                    <b>نوع گواهی: </b>  {model && model.CertificationType && model.CertificationType.Title}  &nbsp;&nbsp;
                    <b>تاریخ درخواست: </b>  {model && moment(model.RequestDate).isValid() && moment(model.RequestDate).format('jYYYY/jMM/jDD')}  &nbsp;&nbsp;
                    <b>پزشک: </b>  {model && model.Physician && model.Physician.FullName}  &nbsp;&nbsp;   
                    <b>وضعیت: </b>  {model && requestState[model.RequestState]}    
                    </a>                   
                </div>
                <div id = "certreq" className = "panel-collapse collapse">
                    <div class="panel-body">

                        <div className="form-horizontal">

                            <div className="col-md-3">

                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">گروه گواهی</label>
                                    <div class="col-sm-8">
                                        {model && model.CertificationTypeGroup && model.CertificationTypeGroup.Title}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">نوع گواهی</label>
                                    <div class="col-sm-8">
                                        {model && model.CertificationType && model.CertificationType.Title}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-5" for="email">شماره گواهی</label>
                                    <div class="col-sm-7">
                                        {model && model.UniqueNo }
                                    </div>
                                </div>
                                

                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">تاریخ نامه</label>
                                    <div class="col-sm-8">
                                        {model && moment(model.ReferenceLetterDate).isValid() && moment(model.ReferenceLetterDate).format('jYYYY/jMM/jDD') }   
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4" for="email">شماره نامه</label>
                                    <div class="col-sm-8">
                                        {model && model.ReferenceLetterNo}   
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <label class="control-label col-sm-5" for="email">تاریخ درخواست</label>
                                    <div class="col-sm-7">
                                        {model && moment(model.RequestDate).isValid() && moment(model.RequestDate).format('jYYYY/jMM/jDD')}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">وضعیت</label>
                                    <div class="col-sm-9">
                                        {model && requestState[model.RequestState]}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                               
                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">پزشک</label>
                                    <div class="col-sm-9">
                                        {model && model.Physician && model.Physician.FullName}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="control-label col-sm-3" for="email">مرجع</label>
                                    <div class="col-sm-9">
                                        {model && model.CertificationReference && model.CertificationReference.Title}
                                    </div>
                                </div>
                            </div>
                            
                        
                        
                        </div>


                    </div>
                </div>
            </div>
        );
    }
}
 
export default CertReqPartial;